<template>
  <div class="Bgc-white">
    <Header />
    <div class="contentContacto">
      <div class="container contacto">
        <div class="row justify-content-center">
          <div class="col-lg-10 col-12 align-items-center position-relative cancelarReserva mb-5">
            <!-- Datos de estancia -->
            <b-card-group deck>
              <b-card header-tag="header" footer-tag="footer">
                <p
                  v-if="!newTi"
                  slot="header"
                  class="mb-0 text-lg-center text-left subtitle my-2"
                >{{$t('language.posadasCorporate.reservacionConfirmacion.agradecimiento')}}</p>
                <p
                  v-if="newTi"
                  slot="header"
                  class="mb-0 text-lg-center text-left subtitle my-2"
                >{{$t('language.posadasCorporate.reservacionConfirmacion.diffeTi')}}</p>

                <p slot="header" class="mb-0 text-lg-center text-left my-2">
                  <span
                    class="pr-3 numConfimacion"
                    v-for="item in reservationResponse"
                    :key="item.id"
                  >
                    {{((item.reservationNumber==0||item.reservationNumber=="0")?"": ($t('language.posadasCorporate.reservacionConfirmacion.numConfirm')) )}}
                    <span>
                      {{((item.reservationNumber==0||item.reservationNumber=="0")?"": item.id )}}
                      <span>{{((item.reservationNumber==0||item.reservationNumber=="0")?"": ":" )}}</span>
                    </span>
                    <span class="referencia subtitle numConfimacion">{{item.reservationNumber}}</span>
                  </span>
                </p>

                <div>
                  <p
                    class="estancia mb-4 mt-3"
                    v-b-toggle.estancia
                    @click="(iconoActivoUno == 0) ? iconoActivoUno = 100 : iconoActivoUno = 0"
                  >
                    <i class="icon-building"></i>
                    {{$t('language.posadasCorporate.reservacionConfirmacion.datosEstancia')}}
                    <i
                      class="navi icon-up"
                      :class="(iconoActivoUno  == 0) ? 'oculto' : ''"
                    ></i>
                    <i
                      class="navi icon-navigate-down"
                      :class="(iconoActivoUno  == 0) ? 'camposActive' : 'oculto'"
                    ></i>
                  </p>
                </div>

                <b-collapse id="estancia" visible class="row mt-4">
                  <div class="col-12 col-lg-6">
                    <div>
                      <img
                        class="d-inline-block mr-3"
                        :src="datosHabHotSelected.hotel.img"
                        alt="Contenido no disponible"
                      />
                    </div>
                  </div>
                  <div class="col-12 col-lg-6">
                    <div>
                      <p class="d-inline-block">
                        <b class="subtitle">{{datosHabHotSelected.hotelName}}</b>
                      </p>
                      <ul class="listIconModal row">
                        <li class="row col-6 d-inline">
                          <p class="col-12 mb-3">
                            <i class="demo-icon icon-check-in pr-2"></i>
                            {{$t('language.posadasCorporate.reservacionConfirmacion.entrada')}}: {{arriveTime}} h
                          </p>
                        </li>
                        <li class="row col-6 d-inline">
                          <p class="col-12 mb-3">
                            <i class="demo-icon icon-check-out pr-2"></i>
                            {{$t('language.posadasCorporate.reservacionConfirmacion.salida')}}: {{leaveTime}} h
                            <span id="checkOutTooltip" class="icon-info PC-color--colorBase3"></span>
                          </p>
                        </li>
                        <li class="row col-12 d-inline-flex d-lg-flex">
                          <p class="col-12 mb-3">
                            <i class="demo-icon icon-telephone pr-2"></i>
                            {{detailHotelInfo.hotelPhone}}
                          </p>
                        </li>
                        <li class="row col-12">
                          <p class="col-12 mb-3">
                            <i class="demo-icon icon-location pr-2"></i>
                            {{detailHotelInfo.hotelAddress}}
                          </p>
                        </li>
                        <li class="row col-12">
                          <p class="col-12 mb-3 azul cursor">
                            <i class="pr-2"></i>
                            <a
                              target="_blank"
                              v-bind:href="srcMaps"
                              style="color: #005a83 !important; text-decoration: none;"
                            >{{$t('language.posadasCorporate.reservacionesCancelada.text6')}}</a>
                            <i class="demo-icon icon-arrow-right"></i>
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </b-collapse>

                <!-- HERE GOES RESERVATION -->

                <!--  HERE ENDS RESERVATION -->
              </b-card>
            </b-card-group>

            <!-- personales -->
            <b-card-group deck>
              <b-card header-tag="header" footer-tag="footer">
                <div>
                  <p
                    class="estancia mb-4 mt-3"
                    v-b-toggle.personaleshuesped
                    @click="(iconoActivoDos == 1) ? iconoActivoDos = 200 : iconoActivoDos = 1"
                  >
                    <i class="icon-user"></i>
                    {{$t('language.posadasCorporate.reservacionConfirmacion.datosPersonales')}}
                    <i
                      class="navi icon-up"
                      :class="(iconoActivoDos == 1) ? 'oculto' : ''"
                    ></i>
                    <i
                      class="navi icon-navigate-down"
                      :class="(iconoActivoDos == 1) ? 'camposActive' : 'oculto'"
                    ></i>
                  </p>
                </div>

                <b-collapse id="personaleshuesped" visible class="row">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-12 col-lg-3">
                        <p
                          class="infoResaltado mb-0"
                        >{{$t('language.posadasCorporate.reservacionConfirmacion.nombreUsuario')}}</p>
                        <p
                          class="info"
                        >{{dataPersonalH1.simpleName.toUpperCase()}} {{dataPersonalH1.fatherSurname.toUpperCase()}} {{motherSurnameA.toUpperCase()}}{{(dataPersonalH1.simpleName===''&&dataPersonalH1.fatherSurname===''&&dataPersonalH1.motherSurname===''?guiones:'')}}</p>
                      </div>
                      <div class="col-12 col-lg-3">
                        <p
                          class="infoResaltado mb-0"
                        >{{$t('language.posadasCorporate.reservacionConfirmacion.numEmpleado')}}</p>
                        <p
                          class="info"
                        >{{(dataPersonalH1.agentNumber===''?guiones:dataPersonalH1.agentNumber)}}</p>
                      </div>
                      <div class="col-12 col-lg-3">
                        <p
                          class="infoResaltado mb-0"
                        >{{$t('language.posadasCorporate.reservacionConfirmacion.numFiestaReward')}}</p>
                        <p
                          class="info"
                        >{{(dataPersonalH1.rewardsNumber===''?guiones:dataPersonalH1.rewardsNumber)}}</p>
                      </div>
                      <div class="col-12 col-lg-3">
                        <p
                          class="infoResaltado mb-0"
                        >{{$t('language.posadasCorporate.reservacionConfirmacion.numApreciare')}}</p>
                        <p
                          class="info"
                        >{{(dataPersonalH1.apreciation===''?guiones:dataPersonalH1.apreciation)}}</p>
                      </div>
                      <div class="col-12 col-lg-3">
                        <p
                          class="infoResaltado mb-0"
                        >{{$t('language.posadasCorporate.reservacionConfirmacion.centroCosto')}}</p>
                        <p
                          class="info"
                        >{{(dataPersonalH1.costCenter===''?guiones:dataPersonalH1.costCenter)}}</p>
                      </div>
                      <div class="col-12 col-lg-3">
                        <p
                          class="infoResaltado mb-0"
                        >{{$t('language.posadasCorporate.reservacionConfirmacion.nombreAcompaniante')}}</p>
                        <p
                          class="info"
                        >{{nameA.toUpperCase()}} {{lastNameA.toUpperCase()}} {{secondLastNameA.toUpperCase()}}{{(nameA==''&&lastNameA==''&&lastNameA==''?guiones:'')}}</p>
                      </div>
                      <div class="col-12 col-lg-3">
                        <p
                          class="infoResaltado mb-0"
                        >{{$t('language.posadasCorporate.reservacionConfirmacion.motiva')}}</p>
                        <p class="info">{{(numMotiva===''?guiones:numMotiva)}}</p>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </b-card>
            </b-card-group>

            <!-- DATOS DE RESERVA -->

            <b-card-group deck>
              <b-card header-tag="header" footer-tag="footer">
                <div>
                  <p
                    class="estancia mb-4 mt-3"
                    v-b-toggle.reserva
                    @click="(iconoActivoTres == 2) ? iconoActivoTres = 300 : iconoActivoTres = 2"
                  >
                    <i class="icon-bed"></i>

                    {{$t('language.posadasCorporate.reservacionesCancelada.text14')}}
                    <i
                      class="navi icon-up"
                      :class="(iconoActivoTres == 2) ? 'oculto' : ''"
                    ></i>
                    <i
                      class="navi icon-navigate-down"
                      :class="(iconoActivoTres == 2) ? 'camposActive' : 'oculto'"
                    ></i>
                  </p>
                </div>

                <b-collapse id="reserva" visible class="row">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-12">
                        <p class="d-inline-block mb-0">
                          <b
                            class="subtitle"
                          >{{$t('language.posadasCorporate.reservacionConfirmacion.habitaciones')}}</b>
                        </p>
                      </div>
                      <div class="col-12">
                        <p class="parrafoInfo">{{datosHabHotSelected.hotel.title}}</p>
                        <ul class="listIconModal row">
                          <li class="row col-12 col-lg-4">
                            <i class="demo-icon icon-calendar col-1"></i>
                            <p class="col-10 mb-3 infoHabitacion">
                              {{globalFunctions.convertBeautifulDate((datosHabHotSelected.habitacion.arrivalDate==undefined||datosHabHotSelected.habitacion.arrivalDate==null||datosHabHotSelected.habitacion.arrivalDate==''?datosHabHotSelected.habitacion.beautiDateInput:datosHabHotSelected.habitacion.arrivalDate), ls.get('Language').data)}} - {{globalFunctions.convertBeautifulDate((datosHabHotSelected.habitacion.departureDate==undefined||datosHabHotSelected.habitacion.departureDate==null||datosHabHotSelected.habitacion.departureDate==''?datosHabHotSelected.habitacion.beautiDateOutput:datosHabHotSelected.habitacion.departureDate), ls.get('Language').data)}}
                              <br />
                              <span
                                class="notasInfoReserva"
                              >{{datosHabHotSelected.hotel.nights}} {{datosHabHotSelected.hotel.nights===1?$t('language.posadasCorporate.generals.noche'):$t('language.posadasCorporate.generals.noches')}}</span>
                            </p>
                          </li>
                          <li class="row col-12 col-lg-4">
                            <i class="demo-icon icon-bed col-1"></i>
                            <p class="col-10 mb-3 infoHabitacion">
                              {{datosHabHotSelected.habitacion.totalRooms}} {{datosHabHotSelected.habitacion.totalRooms===1?$t('language.posadasCorporate.detalleCosto.habitacion'):$t('language.posadasCorporate.detalleCosto.habitaciones')}}
                              <br />
                              <span
                                class="notasInfoReserva"
                              >{{datosHabHotSelected.hotel.negotiatedRatesDetailPrice.rateType}}</span>
                            </p>
                          </li>
                          <li class="row col-12 col-lg-4">
                            <i class="demo-icon icon-user col-1"></i>
                            <p class="col-10 mb-3 infoHabitacion">
                              {{(datosHabHotSelected.habitacion.totalAdults+datosHabHotSelected.habitacion.totalChildren+datosHabHotSelected.habitacion.totalInfants)}} {{(datosHabHotSelected.habitacion.totalAdults+datosHabHotSelected.habitacion.totalChildren+datosHabHotSelected.habitacion.totalInfants)===1?$t('language.posadasCorporate.sidebarReserva.huesped'):$t('language.posadasCorporate.sidebarReserva.huespedes')}}
                              <br />
                              <span
                                class="notasInfoReserva"
                              >{{datosHabHotSelected.habitacion.totalAdults}} {{datosHabHotSelected.habitacion.totalAdults===1?$t('language.posadasCorporate.sidebarReserva.adulto'):$t('language.posadasCorporate.sidebarReserva.adultos')}}{{datosHabHotSelected.habitacion.totalChildren===0?'':datosHabHotSelected.habitacion.totalChildren===1?', ' + datosHabHotSelected.habitacion.totalChildren + ' ' + $t('language.posadasCorporate.sidebarReserva.menor'): ', ' + datosHabHotSelected.habitacion.totalChildren + ' ' + $t('language.posadasCorporate.sidebarReserva.menores')}}{{datosHabHotSelected.habitacion.totalInfants===0?'':datosHabHotSelected.habitacion.totalInfants===1?', ' + datosHabHotSelected.habitacion.totalInfants + ' ' + $t('language.posadasCorporate.sidebarReserva.infante'): ', ' + datosHabHotSelected.habitacion.totalInfants + ' ' + $t('language.posadasCorporate.sidebarReserva.infantes')}}</span>
                            </p>
                          </li>
                        </ul>
                      </div>

                      <div class="col-12">
                        <p class="d-inline-block mb-0">
                          <b
                            class="subtitle"
                          >{{$t('language.posadasCorporate.reservacionConfirmacion.comodidadesIncluidas')}}</b>
                        </p>
                      </div>
                      <div class="col-12">
                        <div
                          style="display:inline; margin-left:10px;"
                          v-for="(amenity, index) of detailHotelInfo.amenityList"
                          :key="'amenity_' + index"
                        >
                          <i
                            v-b-popover.hover.top="{ content: amenity.amenityName, customClass:'PC-popover' }"
                          >
                            <img :src="amenity.amenityIcon" />
                          </i>
                        </div>
                      </div>

                      <div class="col-12">
                        <p class="d-inline-block mb-0">
                          <b
                            class="subtitle"
                          >{{$t('language.posadasCorporate.reservacionConfirmacion.suplementos')}}</b>
                        </p>
                        <p v-if="banSuplementMand"
                            class="parrafoInfo"
                          >{{$t('language.posadasCorporate.reservacionConfirmacion.suMan')}}
                        </p>
                         <p v-if="banSuplementMA">
                          <span>{{descriptionMA}}</span>
                        </p>

                        <p v-if="banConsiEspe"
                            class="parrafoInfo"
                          >{{$t('language.posadasCorporate.reservacionConfirmacion.consiEspe')}}
                        </p>
                        <p v-if="banConsiEspe">
                          <span>{{considEspe}}</span>
                        </p>
                      </div>
                      <div class="col-12">
                        <p
                          class="parrafoInfo"
                          v-if="banSuplement"
                        >{{$t('language.posadasCorporate.reservacionConfirmacion.suplementosIncluidos')}}</p>
                        <p
                          v-if="banSuplement"
                        >{{supleER}}</p>
                        <p v-if="!banSuplement">
                          <span class="parrafoInfo">{{guiones}}</span>
                        </p>

                        <p v-if="optionalSuplOff" class="parrafoInfo">Suplementos opcionales</p>
                        <p v-if="optionalSuplOff" class>Suplemento opcional número 1</p>
                        <p v-if="optionalSuplOff" class>Suplemento opcional número 2</p>
                      </div>

                      <div class="col-12" v-if="(requirementsDataH1===null||requirementsDataH1==='.'?false:true)">
                        <p class="d-inline-block mb-0">
                          <b
                            class="subtitle"
                          >{{$t('language.posadasCorporate.reservacionConfirmacion.requerimientos')}}</b>
                        </p>
                      </div>
                      <div class="col-12">
                        <p
                          v-if="(requirementsDataH1===null||requirementsDataH1==='.'?false:true)"
                          class="parrafoInfo"
                        >{{$t('language.posadasCorporate.reservacionConfirmacion.habitacion')}} 1</p>
                        <p
                          v-if="(requirementsDataH1===null||requirementsDataH1==='.'?false:true)"
                          style="display:inline"
                        >{{requirementsDataH1}}</p>
                        <br v-if="(requirementsDataH2===null||requirementsDataH2==='.'?false:true)" />
                        <br v-if="(requirementsDataH2===null||requirementsDataH2==='.'?false:true)" />

                        <p
                          v-if="(requirementsDataH2===null||requirementsDataH2==='.'?false:true)"
                          class="parrafoInfo"
                        >{{$t('language.posadasCorporate.reservacionConfirmacion.habitacion')}} 2</p>
                        <p
                          v-if="(requirementsDataH2===null||requirementsDataH2==='.'?false:true)"
                          style="display:inline"
                        >{{requirementsDataH2}}</p>
                        <br v-if="(requirementsDataH3===null||requirementsDataH3==='.'?false:true)" />
                        <br v-if="(requirementsDataH3===null||requirementsDataH3==='.'?false:true)" />

                        <p
                          v-if="(requirementsDataH3===null||requirementsDataH3==='.'?false:true)"
                          class="parrafoInfo"
                        >{{$t('language.posadasCorporate.reservacionConfirmacion.habitacion')}} 3</p>
                        <p
                          v-if="(requirementsDataH3===null||requirementsDataH3==='.'?false:true)"
                          style="display:inline"
                        >{{requirementsDataH3}}</p>
                        <br v-if="(requirementsDataH4===null||requirementsDataH4==='.'?false:true)" />
                        <br v-if="(requirementsDataH4===null||requirementsDataH4==='.'?false:true)" />

                        <p
                          v-if="(requirementsDataH4===null||requirementsDataH4==='.'?false:true)"
                          class="parrafoInfo"
                        >{{$t('language.posadasCorporate.reservacionConfirmacion.habitacion')}} 4</p>
                        <p
                          v-if="(requirementsDataH4===null||requirementsDataH4==='.'?false:true)"
                          style="display:inline"
                        >{{requirementsDataH4}}</p>
                        <br v-if="(requirementsDataH5===null||requirementsDataH5==='.'?false:true)" />
                        <br v-if="(requirementsDataH5===null||requirementsDataH5==='.'?false:true)" />

                        <p
                          v-if="(requirementsDataH5===null||requirementsDataH5==='.'?false:true)"
                          class="parrafoInfo"
                        >{{$t('language.posadasCorporate.reservacionConfirmacion.habitacion')}} 5</p>
                        <p
                          v-if="(requirementsDataH5===null||requirementsDataH5==='.'?false:true)"
                          style="display:inline"
                        >{{requirementsDataH5}}</p>
                        <br />
                        <br />
                      </div>

                      <div class="col-12">
                        <p class="d-inline-block mb-0">
                          <b
                            class="subtitle"
                          >{{$t('language.posadasCorporate.reservacionConfirmacion.beneficios')}}</b>
                        </p>
                      </div>
                      <div class="col-12">
                        <p v-if="block1">{{datosHabHotSelected.hotel.benefitsRestrictions.benefits}}</p>
                        <p v-if="!block1">{{guiones}}</p>

                        <p
                          v-if="block2"
                        >{{datosHabHotSelected.hotel.benefitsRestrictions.restrictions}}</p>
                        <p v-if="!block2"></p>
                      </div>

                      <div class="col-12 row justify-content-lg-end justify-content-start">
                        <div class="row col-12 col-lg-6 float-right">
                          <div class="col-6">
                            <p
                              class="subtitle mb-0"
                            >{{ $t('language.posadasCorporate.generals.totalEstanciaImpuestos') }} {{datosHabHotSelected.hotel.nights}} {{datosHabHotSelected.hotel.nights===1?$t('language.posadasCorporate.generals.noche'):$t('language.posadasCorporate.generals.noches')}}:</p>
                            <span class="PC-text--size12 PC-color--grayBrownish">
                              {{datosHabHotSelected.habitacion.totalRooms}} {{datosHabHotSelected.habitacion.totalRooms===1?$t('language.posadasCorporate.detalleCosto.habitacion'):$t('language.posadasCorporate.detalleCosto.habitaciones')}}
                            </span>
                          </div>
                          <div class="col-6">
                            <br>
                            <p class="subtitle mb-0 text-right">
                              $ {{((infoCosto.data.userClientID==pyp||infoCosto.data.userClientID==pypsa||!showRates)&&infoCosto.data.tabActive===1?guiones:getTotalStayConfirReser ? globalFunctions.numberFormat(doesIt, 2, '.', ',') : globalFunctions.numberFormat(datosHabHotSelected.hotel.negotiatedRatesDetailPrice.totalRateWithTaxes, 2, '.', ',') )   }} <!-- datosHabHotSelected.hotel.negotiatedRatesDetailPrice.totalRateWithTaxes -->
                              <span class="moneda">{{datosHabHotSelected.habitacion.currencyCode}}</span>
                            </p>
                            <p
                              class="notasInfoReserva mt-0 mb-1 text-right"
                            >{{$t('language.posadasCorporate.reservacionConfirmacion.iva')}}</p>
                            <p class="text-right ver-detalleInfoReserva">
                              <a
                                class="enlaceDetalle"
                                @click.prevent="verDetalle"
                                href
                              >{{$t('language.posadasCorporate.reservacionConfirmacion.verDetalle')}}</a>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </b-card>
            </b-card-group>

            <!-- FIN DATOS DE RESERVA -->

            <!-- agencia o compañia -->
            <b-card-group deck>
              <b-card header-tag="header" footer-tag="footer">
                <div>
                  <p
                    class="estancia mb-4 mt-3"
                    v-b-toggle.agencia
                    @click="(iconoActivoCuatro == 3) ? iconoActivoCuatro = 400 : iconoActivoCuatro = 3"
                  >
                    <i class="icon-building"></i>
                    {{$t('language.posadasCorporate.reservacionConfirmacion.datosCompania')}}
                    <i
                      class="navi icon-up"
                      :class="(iconoActivoCuatro == 3) ? 'oculto' : ''"
                    ></i>
                    <i
                      class="navi icon-navigate-down"
                      :class="(iconoActivoCuatro == 3) ? 'camposActive' : 'oculto'"
                    ></i>
                  </p>
                </div>

                <b-collapse id="agencia" visible class="row">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-12 col-lg-3">
                        <p
                          class="infoResaltado mb-0"
                        >{{$t('language.posadasCorporate.reservacionConfirmacion.nombreCompania')}}</p>
                        <p
                          class="info"
                        >{{ (nombreCompania===''||nombreCompania===null||nombreCompania===undefined?guiones:nombreCompania) }}</p>
                      </div>
                      <div class="col-12 col-lg-3">
                        <p
                          class="infoResaltado mb-0"
                        >{{$t('language.posadasCorporate.reservacionConfirmacion.clienteId')}}</p>
                        <p class="info">{{clientIdLogin}}</p>
                      </div>
                      <div class="col-12 col-lg-3">
                        <p
                          class="infoResaltado mb-0"
                        >{{$t('language.posadasCorporate.reservacionConfirmacion.razonSocial')}}</p>
                        <p
                          class="info"
                        >{{((metodosPagoData.data.razonSeleccionada=='' || metodosPagoData.data.razonSeleccionada==null || metodosPagoData.data.razonSeleccionada=="undefined")?guiones:metodosPagoData.data.razonSeleccionada)}}</p>
                      </div>
                      <div class="col-12 col-lg-3">
                        <p
                          class="infoResaltado mb-0"
                        >{{$t('language.posadasCorporate.reservacionConfirmacion.rfc')}}</p>
                        <p
                          class="info"
                        >{{((metodosPagoData.data.agencyRFC=='' || metodosPagoData.data.agencyRFC==null || metodosPagoData.data.agencyRFC=="undefined")?guiones:metodosPagoData.data.agencyRFC)}}</p>
                      </div>
                      <div class="col-12 col-lg-3">
                        <p
                          class="infoResaltado mb-0"
                        >{{$t('language.posadasCorporate.reservacionConfirmacion.direccion')}}</p>
                        <p
                          class="info"
                        >{{((metodosPagoData.data.agencyAddress=='' || metodosPagoData.data.agencyAddress==null || metodosPagoData.data.agencyAddress=="undefined")?guiones:metodosPagoData.data.agencyAddress)}}</p>
                      </div>
                      <div class="col-12 col-lg-3">
                        <p
                          class="infoResaltado mb-0"
                        >{{$t('language.posadasCorporate.reservacionConfirmacion.telefono')}}</p>
                        <p
                          class="info"
                        >{{((metodosPagoData.data.agencyPhone=='' || metodosPagoData.data.agencyPhone==null || metodosPagoData.data.agencyPhone=="undefined")?guiones:metodosPagoData.data.agencyPhone)}}</p>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </b-card>
            </b-card-group>

            <!-- metodo pago -->
            <b-card-group deck>
              <b-card header-tag="header" footer-tag="footer">
                <div>
                  <p
                    class="estancia mb-4 mt-3"
                    v-b-toggle.pago
                    @click="(iconoActivoCinco == 4) ? iconoActivoCinco = 500 : iconoActivoCinco = 4"
                  >
                    <i class="icon-currency"></i>
                    {{$t('language.posadasCorporate.reservacionConfirmacion.metodoPago')}}
                    <i
                      class="navi icon-up"
                      :class="(iconoActivoCinco == 4) ? 'oculto' : ''"
                    ></i>
                    <i
                      class="navi icon-navigate-down"
                      :class="(iconoActivoCinco == 4) ? 'camposActive' : 'oculto'"
                    ></i>
                  </p>
                </div>

                <b-collapse id="pago" visible class="row">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-12 col-lg-3">
                        <p
                          class="infoResaltado mb-0"
                        >{{$t('language.posadasCorporate.reservacionConfirmacion.metodoPago')}}</p>
                        <p class="info" v-if="!isTokenToCard">{{metodosPagoData.data.metodoPago}}</p>
                        <p class="info" v-if="isTokenToCard">{{langForToken}}</p>
                      </div>
                      <div
                        class="col-12 col-lg-3"
                        v-if="metodosPagoData.data.metodoPago == 'Voucher'"
                      >
                        <p
                          class="infoResaltado mb-0"
                        >{{$t('language.posadasCorporate.reservacionConfirmacion.folio')}}</p>
                        <p class="info">{{metodosPagoData.data.voucherFolio}}</p>
                      </div>

                      <div
                        class="col-12 col-lg-3"
                        v-if="metodosPagoData.data.metodoPago == 'Credito'"
                      >
                        <p
                          class="infoResaltado mb-0"
                        >{{$t('language.posadasCorporate.reservacionConfirmacion.numFolioCupon')}}</p>
                        <p
                          class="info"
                        >{{((metodosPagoData.data.creditoEmpresaFolio=='' || metodosPagoData.data.creditoEmpresaFolio==null || metodosPagoData.data.creditoEmpresaFolio=="undefined")?guiones:metodosPagoData.data.creditoEmpresaFolio)}}</p>
                      </div>

                      <!-- PROMO AND DISCOUNT -->
                      <div
                        class="col-12 col-lg-3"
                        v-if="metodosPagoData.data.metodoPago == 'Tarjeta de Crédito' || metodosPagoData.data.metodoPago == 'Voucher' || metodosPagoData.data.metodoPago == 'Tiempo límite' || metodosPagoData.data.metodoPago == 'Credito'"
                      >
                        <p
                          class="infoResaltado mb-0"
                        >{{$t('language.posadasCorporate.reservacionConfirmacion.disCode')}}</p>
                        <p
                          class="info"
                        >{{((disCode=='' || disCode==null || disCode=="undefined")?guiones:disCode)}}</p>
                      </div>
                      <div
                        class="col-12 col-lg-3"
                        v-if="metodosPagoData.data.metodoPago == 'Tarjeta de Crédito' || metodosPagoData.data.metodoPago == 'Voucher' || metodosPagoData.data.metodoPago == 'Tiempo límite' || metodosPagoData.data.metodoPago == 'Credito'"
                      >
                        <p
                          class="infoResaltado mb-0"
                        >{{$t('language.posadasCorporate.reservacionConfirmacion.promCode')}}</p>
                        <p
                          v-if="rateNameDC"
                          class="info"
                        >{{((proCode=='' || proCode==null || proCode=="undefined")?guiones:proCode)}}</p>
                        <p v-if="!rateNameDC" class="info">{{rateNameDisplayDC}}</p>
                      </div>

                      <!-- PROMO AND DISCOUNT -->

                      <div
                        class="col-12 col-lg-3"
                        v-if="metodosPagoData.data.metodoPago == 'Tarjeta de Crédito'"
                      >
                        <p
                          class="infoResaltado mb-0"
                        >{{$t('language.posadasCorporate.reservacionConfirmacion.tipoTarjeta')}}</p>
                        <p class="info">{{metodosPagoData.data.creditoTarjetaSeleccionada}}</p>
                      </div>
                      <div
                        class="col-12 col-lg-3"
                        v-if="metodosPagoData.data.metodoPago == 'Tarjeta de Crédito'"
                      >
                        <p
                          class="infoResaltado mb-0"
                        >{{$t('language.posadasCorporate.reservacionConfirmacion.numTarjeta')}}</p>
                        <p class="info">{{hiddenCode}}</p>
                      </div>
                      <div
                        class="col-12 col-lg-3"
                        v-if="metodosPagoData.data.metodoPago == 'Tarjeta de Crédito'"
                      >
                        <p
                          class="infoResaltado mb-0"
                        >{{$t('language.posadasCorporate.reservacionConfirmacion.nombreTarjetahabiente')}}</p>
                        <p class="info">{{metodosPagoData.data.creditoNombre.toUpperCase()}}</p>
                      </div>
                      <div
                        class="col-12 col-lg-3"
                        v-if="metodosPagoData.data.metodoPago == 'Tarjeta de Crédito'"
                      >
                        <p
                          class="infoResaltado mb-0"
                        >{{$t('language.posadasCorporate.reservacionConfirmacion.fechaVencimiento')}}</p>
                        <p class="info">{{mois}}{{anne}}</p>
                      </div>

                      <!-- PROMO AND DISCOUNT -->
                      <div
                        class="col-12 col-lg-3"
                        v-if="metodosPagoData.data.metodoPago == 'Token'"
                      >
                        <p
                          class="infoResaltado mb-0"
                        >{{$t('language.posadasCorporate.reservacionConfirmacion.disCode')}}</p>
                        <p
                          class="info"
                        >{{((disCode=='' || disCode==null || disCode=="undefined")?guiones:disCode)}}</p>
                      </div>
                      <div
                        class="col-12 col-lg-3"
                        v-if="metodosPagoData.data.metodoPago == 'Token'"
                      >
                        <p
                          class="infoResaltado mb-0"
                        >{{$t('language.posadasCorporate.reservacionConfirmacion.promCode')}}</p>
                        <p
                          v-if="rateNameDC"
                          class="info"
                        >{{((proCode=='' || proCode==null || proCode=="undefined")?guiones:proCode)}}</p>
                        <p v-if="!rateNameDC" class="info">{{rateNameDisplayDC}}</p>
                      </div>

                      <!-- PROMO AND DISCOUNT -->

                      <div
                        class="col-12 col-lg-3"
                        v-if="metodosPagoData.data.metodoPago == 'Token'"
                      >
                        <p
                          class="infoResaltado mb-0"
                        >{{$t('language.posadasCorporate.reservacionConfirmacion.tipoTarjeta')}}</p>
                        <p class="info">{{metodosPagoData.data.creditoTarjetaSeleccionada}}</p>
                      </div>
                      <div
                        class="col-12 col-lg-3"
                        v-if="metodosPagoData.data.metodoPago == 'Token'"
                      >
                        <p
                          class="infoResaltado mb-0"
                        >{{$t('language.posadasCorporate.reservacionConfirmacion.numTarjeta')}}</p>
                        <p class="info">{{hiddenCode}}</p>
                      </div>
                      <div
                        class="col-12 col-lg-3"
                        v-if="metodosPagoData.data.metodoPago == 'Token'"
                      >
                        <p
                          class="infoResaltado mb-0"
                        >{{$t('language.posadasCorporate.reservacionConfirmacion.nombreTarjetahabiente')}}</p>
                        <p class="info">{{metodosPagoData.data.creditoNombre.toUpperCase()}}</p>
                      </div>
                      <div
                        class="col-12 col-lg-3"
                        v-if="metodosPagoData.data.metodoPago == 'Token'"
                      >
                        <p
                          class="infoResaltado mb-0"
                        >{{$t('language.posadasCorporate.reservacionConfirmacion.fechaVencimiento')}}</p>
                        <p class="info">{{mois}}{{anne}}</p>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </b-card>
            </b-card-group>

            <!-- politica de viaje -->
            <b-card-group deck>
              <b-card header-tag="header" footer-tag="footer">
                <div>
                  <p
                    class="estancia mb-4 mt-3"
                    v-b-toggle.politica
                    @click="(iconoActivoSeis == 5) ? iconoActivoSeis = 600 : iconoActivoSeis = 5"
                  >
                    <i class="icon-travel"></i>
                    {{$t('language.posadasCorporate.reservacionConfirmacion.politicaViaje')}}
                    <i
                      class="navi icon-up"
                      :class="(iconoActivoSeis == 5) ? 'oculto' : ''"
                    ></i>
                    <i
                      class="navi icon-navigate-down"
                      :class="(iconoActivoSeis == 5) ? 'camposActive' : 'oculto'"
                    ></i>
                  </p>
                </div>

                <b-collapse id="politica" visible class="row">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-12">
                        <p class="d-inline-block mb-0">
                          <b
                            class="subtitle"
                          >{{((metodosPagoData.data.creditoPoliticaSeleccionada=='' || metodosPagoData.data.creditoPoliticaSeleccionada==null || metodosPagoData.data.creditoPoliticaSeleccionada=="undefined")?guiones:metodosPagoData.data.creditoPoliticaSeleccionada)}}</b>
                        </p>
                      </div>
                      <div class="col-12">
                        <p class="info">{{policiesNow}}</p>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </b-card>
            </b-card-group>

            <!-- politica de cambio y cancelacion -->
            <b-card-group deck>
              <b-card header-tag="header" footer-tag="footer">
                <div class="col-12 row align-items-center p-0 m-0">
                  <div
                    class="pl-0 col-lg-8 col-11"
                    v-b-toggle.politicasCambio
                    @click="(iconoActivoSiete == 6) ? iconoActivoSiete = 700 : iconoActivoSiete = 6"
                  >
                    <p class="estancia mb-3 mb-lg-4 mt-3">
                      <i class="icon-politics"></i>
                      {{$t('language.posadasCorporate.reservacionConfirmacion.politicasCancelacion')}}
                    </p>
                  </div>
                  <div class="col-lg-3 d-none d-lg-block pr-0">
                    <p
                      class="text-right mb-4 mt-3 link cursor"
                      @click.prevent="redirectAvisoPrivacidad"
                    >
                      {{$t('language.posadasCorporate.reservacionConfirmacion.goOn')}}
                      <i class="icon-report"></i>
                    </p>
                  </div>
                  <div
                    class="col-1 pr-0 pl-0"
                    v-b-toggle.politicasCambio
                    @click="(iconoActivoSiete == 6) ? iconoActivoSiete = 700 : iconoActivoSiete = 6"
                  >
                    <i class="navi icon-up" :class="(iconoActivoSiete == 6) ? 'oculto' : ''"></i>
                    <i
                      class="navi icon-navigate-down"
                      :class="(iconoActivoSiete == 6) ? 'camposActive' : 'oculto'"
                    ></i>
                  </div>
                </div>
                <div class="pr-0 d-lg-none d-block">
                  <p class="mb-4 mt-3 azul" @click.prevent="redirectAvisoPrivacidad">
                    {{$t('language.posadasCorporate.reservacionConfirmacion.goOn')}}
                    <i class="icon-report"></i>
                  </p>
                </div>

                <b-collapse id="politicasCambio" visible class="row">
                  <!-- Limite -->
                  <div
                    class="col-12"
                    v-for="(listPolitica, index) of datosHabHotSelected.politicas.listPoliticas"
                    :key="'_politicas' + index"
                  >
                    <div class="row">
                      <div class="col-12">
                        <p
                          class="subtitle"
                          :class="(iconoNaviActivo == index) ? 'camposActive' : ''"
                          @click="(iconoNaviActivoUno == index) ? iconoNaviActivoUno = 100 : iconoNaviActivoUno = index"
                          v-b-toggle="'_politica' + index"
                        >
                          {{listPolitica.title}}
                          <i
                            class="navi icon-up"
                            :class="(iconoNaviActivoUno == index) ? 'camposActive' : 'oculto'"
                          ></i>
                          <i
                            class="navi icon-navigate-down"
                            :class="(iconoNaviActivoUno == index) ? 'oculto' : ''"
                          ></i>
                        </p>
                      </div>
                      <!-- Formulario -->
                      <b-collapse class="col-12" :id="'_politica' + index">
                        <div class="row">
                          <div class="col-12">                        
                        <p>{{changePolicys(listPolitica.description ,listPolitica.penaltyQuantity, guiones,infoCosto.data.tabActive,infoCosto.data.userClientID)}} </p>
                          </div>
                        </div>
                      </b-collapse>
                    </div>
                    <hr />
                  </div>
                </b-collapse>
              </b-card>
            </b-card-group>

            <!-- Botones -->
            <div class="row botones mt-5">
              <div class="col-12 col-lg-6 botonesInfo order-1 order-lg-2 mb-2 mb-lg-0">
                <router-link to="/">
                  <button
                    class="button"
                    @click="newReservation"
                  >{{$t('language.posadasCorporate.reservacionConfirmacion.nuevaReservacion')}}</button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <DetalleCostos :key="componentKey"></DetalleCostos>
    <Footer />

    <b-popover
      target="checkOutTooltip"
      title
      triggers="hover focus"
      placement="bottom"
      customClass="PC-popover"
      :content="$t('language.posadasCorporate.reservacionConfirmacion.tootlTip')"
    ></b-popover>
  </div>
</template>

<script>
import * as GlobalFunctions from "../../../utils/GlobalFunctions";
import * as GlobalServices from "../../../utils/GlobalServices";
import Header from "../../generales/Header.vue";
import Footer from "../../generales/Footer.vue";
import DetalleCostos from "../DetalleCostos";
import SecureLS from "secure-ls";
import Modal from "../../addons/Modal.vue";

export default {
  name: "ReservacionesConfirmacion",
  components: {
    Header,
    Footer,
    DetalleCostos,
    Modal
  },
  data: () => {
    return {
      groupBool: false,
      isUserGeneric: false,
      getTotalStayConfirReser: false,
            plusDeChambres: 1,
doesIt: 0,
      listRequeOpcionalesSeleccionados: [],
      banConsiEspe: false,
      considEspe: '',
      banSuplementMand: false,
descriptionMA: "",
banSuplementMA: false,
      nombreCompania: '',
      supleER: "",
      numMotiva: "",
      newTi: false,
      rateNameDisplayDC: "",
      rateNameDC: true,
      optionalSuplOff: false,
      pyp: "PYP", //no cambiar este valor
      pypsa: "PYPSA", //no cambiar este valor
      guiones: "-------", //no cambiar este valor
      twoPolicy: 'igual a 2',
      twoPolicyEn: 'equal to 2',
      showRates: null,
      hiddenCode: "",
      isTokenToCard: false,
      langForToken: "es",
      clientIdLogin: "",
      disCode: "",
      proCode: "",
      mois: "",
      anne: "",
      motherSurnameA: "",
      nameA: "",
      lastNameA: "",
      secondLastNameA: "",
      a: "aaa",
      b: "bbb",
      c: "ccc",
      policiesNow: "",
      block1: false,
      block2: false,
      banSuplement: false,
      listSuplement: [],
      modalListCosteCommissionAmount: "",
      modalListCosteCommissionPercentage: "",
      modalListCosteBaseAmount: "",
      modalListCosteContract: "",
      rateDescriptionText: "",
      rateBenefitsText: "",
      rateBenefitsRestrictions: "",
      showTable: true,
      arriveTime: "",
      leaveTime: "",
      componentKey: 0,
      testingVFOR: [],
      ls: new SecureLS({ encodingType: "aes" }),
      reservationResponse: [],
      globalFunctions: GlobalFunctions,
      infoCosto: null,
      banDetalleCosto: false,
      banDetalleCostoTooltip: false,
      datosHabHotSelected: null,
      detailHotelInfo: null,
      iconoActivo: 99,
      iconoNaviActivo: 99,
      iconoActivoUno: null,
      iconoActivoDos: null,
      iconoActivoTres: null,
      iconoActivoCuatro: null,
      iconoActivoCinco: null,
      iconoActivoSeis: null,
      iconoActivoSiete: null,
      iconoNaviActivo: null,
      iconoNaviActivoUno: null,
      iconoNaviActivoDos: null,
      iconoNaviActivoTres: null,
      iconoNaviActivoCuatro: null,
      srcMaps: "",
      metodosPagoData: null,
      dataPersonalH1: null,
      contactDataH1: null,
      CompanyDataH1: null,
      requirementsDataH1: null,
      requirementsDataH2: null,
      requirementsDataH3: null,
      requirementsDataH4: null,
      requirementsDataH5: null,
      average: null,
      noches: null
    };
  },
  created() {
    var ls = new SecureLS({encodingType: 'aes'});
      var grupoInfoLs = ls.get('InfoGrupo')
      this.InfoGrupo = grupoInfoLs.data
     
      var groupInfo = '';
      groupInfo = this.InfoGrupo;
      
      if(groupInfo === undefined || groupInfo === '' ){
        this.groupBool = false;
        
      }
      else{
        this.groupBool = true;
      }
        
    this.$store.commit("blockLanguages", { turn: true });
    this.isUserGeneric = this.ls.get('isUserGeneric').data;
        this.$store.commit('updateTotalStay', {optionalSupplementsObject: this.ls.get('updateTotalStay')})
   this.listRequeOpcionalesSeleccionados = this.$store.getters.gettingListRequeOpcionalesSeleccionadosForConfir
   const datSelected = this.ls.get("datosHabHotSelected").data;
    if (datSelected.specialMessage != null && datSelected.specialMessage.length > 0) {
      this.banConsiEspe = true;
      this.considEspe = datSelected.specialMessage[0];
    }
    if(this.ls.get("descriptionMS") != null && this.ls.get("descriptionMS") != "") {
      this.descriptionMA = this.ls.get("descriptionMS")
      this.banSuplementMA = true 
      this.banSuplementMand = true
    }
    this.ls.set("descriptionMS", "")
    if (this.ls.get("fixA")) {
      this.requirementsDataH1 = this.ls.get("requirementsDataH1");
    }
    if (this.ls.get("changeTitleMod")) {
      this.newTi = true;
    } else {
      this.newTi = false;
    }
    this.dataPersonalH1 = this.ls.get("dataPersonalH1");
    this.showRates = this.ls.get(
      "Profile"
    ).data.ratesPermissionsResponse.showRates;
    this.detailHotelInfo = this.ls.get("DetailHotelInfo").data.response;
    this.cargarInfoLocalStorage();
     this.getTotalStayConfirReser = this.$store.getters.getTotalStayConfirReser
    if(this.$store.getters.getTotalStayConfirReser) {
      this.doesIt = this.ls.get('updateCostDetail').data.hotel.negotiatedRatesDetailPrice.totalRateWithTaxes + ( this.ls.get('updateCostDetail').data.hotel.negotiatedRatesDetailPrice.extraTotalRateWithTaxes * this.plusDeChambres)// + this.ls.get('updateCostDetail').data.hotel.negotiatedRatesDetailPrice.extraTaxes
    }
    this.suplementProforma();
    this.tooltipInfo();
  
   this.average= this.ls.get('updateCostDetail').data.hotel.negotiatedRatesDetailPrice.totalRateWithoutTaxes
   this.noches= this.ls.get('updateCostDetail').data.hotel.nights;
 
    this.srcMaps =
      process.env.VUE_APP_APIMAPS +
      this.detailHotelInfo.hotelLatitude +
      "," +
      this.detailHotelInfo.hotelLongitude +
      "&hl=es;z=14";
    if (
      this.ls.get("rateNameDiscountCode") == null ||
      this.ls.get("rateNameDiscountCode") == ""
    ) {
      this.rateNameDC = true;
    } else {
      this.rateNameDC = false;
      this.rateNameDisplayDC = this.ls.get("rateNameDiscountCode");
    }
    this.arriveTime = this.ls.get("contactDataH1").checkIn;
    this.leaveTime = this.ls.get("contactDataH1").checkOut;
    this.metodosPagoData = this.ls.get("metodosPagoData");
    if (
      this.$store.getters.gettingLang == "es" &&
      this.metodosPagoData.data.metodoPago == "Token"
    ) {
      this.langForToken = "Tarjeta";
      this.isTokenToCard = true;
    }
    if (
      this.$store.getters.gettingLang == "en" &&
      this.metodosPagoData.data.metodoPago == "Token"
    ) {
      this.langForToken = "Card";
      this.isTokenToCard = true;
    }
    if (
      this.$store.getters.gettingLang == "en" &&
      this.metodosPagoData.data.metodoPago == "Tarjeta de Crédito"
    ) {
      this.langForToken = "Credit card";
      this.isTokenToCard = true;
    }
    if (
      this.$store.getters.gettingLang == "en" &&
      this.metodosPagoData.data.metodoPago == "Tiempo límite"
    ) {
      this.langForToken = "Hold time";
      this.isTokenToCard = true;
    }
    if (
      this.$store.getters.gettingLang == "es" &&
      this.metodosPagoData.data.metodoPago == "Tiempo límite"
    ) {
      this.langForToken = "Tiempo límite";
      this.isTokenToCard = true;
    }
    if (
      this.$store.getters.gettingLang == "en" &&
      this.metodosPagoData.data.metodoPago == "Credito"
    ) {
      this.langForToken = "Credit";
      this.isTokenToCard = true;
    }
    if (
      this.$store.getters.gettingLang == "es" &&
      this.metodosPagoData.data.metodoPago == "Credito"
    ) {
      this.langForToken = "Crédito";
      this.isTokenToCard = true;
    }

    if (this.metodosPagoData.data.creditoTipoDeMascara == null) {
    } else {
      var hiddenNumber = this.metodosPagoData.data.creditoTipoDeMascara.substr(
        12
      );
      var asteriks = "**** **** **** ";
      this.hiddenCode = asteriks.concat(hiddenNumber);
    }

    var code1 = this.ls.get("availibilityRequest").data.discountCode;
    var code2 = this.ls.get("availibilityRequest").data.promoCode;
    if (this.ls.get("promoCodeRO") != null) {
      this.proCode = this.ls.get("promoCodeRO");
    }
    if (code1 === "" || code1 === undefined || code1 === null) {
      this.disCode = code2;
    }
    if (code2 === "" || code2 === undefined || code2 === null) {
      this.disCode = code1;
    }

    if (this.ls.get("motivaNumber") != "") {
      this.numMotiva = this.ls.get("motivaNumber");
    } else {
      var motivaAvaibility = this.ls.get("availibilityRequest").data;
      if (
        motivaAvaibility.motivaCode != "" ||
        motivaAvaibility.motivaCode != null
      ) {
        this.numMotiva = motivaAvaibility.motivaCode;
      } else {
        this.numMotiva = "";
      }
    }

    if (
      this.metodosPagoData.data.creditoExpiracion != null &&
      this.metodosPagoData.data.creditoExpiracion != ""
    ) {
      var str = "Hello world!";
      this.mois = this.metodosPagoData.data.creditoExpiracion.substr(0, 2);
      this.anne = this.metodosPagoData.data.creditoExpiracion.substr(2);
    }
    if (
      this.metodosPagoData.data.tokenExpiracion != null &&
      this.metodosPagoData.data.tokenExpiracion != ""
    ) {
      var str = "Hello world!";
      this.mois = this.metodosPagoData.data.tokenExpiracion.substr(0, 2);
      this.anne = this.metodosPagoData.data.tokenExpiracion.substr(2);
    }
    if (this.ls.get("dataPersonalH1").motherSurname == null) {
      this.motherSurnameA = "";
    } else {
      this.motherSurnameA = this.ls.get("dataPersonalH1").motherSurname;
    }

    this.contactDataH1 = this.ls.get("contactDataH1");
    this.CompanyDataH1 = this.ls.get("CompanyDataH1");
    if (this.ls.get("CompanyDataH1").name == null) {
      this.nameA = "";
    } else {
      this.nameA = this.ls.get("CompanyDataH1").name;
    }
    if (this.ls.get("CompanyDataH1").lastName == null) {
      this.lastNameA = "";
    } else {
      this.lastNameA = this.ls.get("CompanyDataH1").lastName;
    }

    if (this.ls.get("CompanyDataH1").secondLastName == null) {
      this.secondLastNameA = "";
    } else {
      this.secondLastNameA = this.ls.get("CompanyDataH1").secondLastName;
    }
    var reqDatH1 = this.ls.get("requirementsDataH1");
    if (reqDatH1 != "") {
      var list = [];
      list.push(reqDatH1.extraPreferencesText);
      list.push(reqDatH1.floorPreferencesText);
      list.push(reqDatH1.preferencesText);
      list.push(reqDatH1.smokingPreferencesText);
      list = list.filter(value => Object.keys(value).length !== 0);
      this.requirementsDataH1 = list.join(", ") + ".";
    }

    var reqDatH2 = this.ls.get("requirementsDataH2");
    if (reqDatH2 != "") {
      var list1 = [];
      list1.push(reqDatH2.extraPreferencesText);
      list1.push(reqDatH2.floorPreferencesText);
      list1.push(reqDatH2.preferencesText);
      list1.push(reqDatH2.smokingPreferencesText);
      list1 = list1.filter(value => Object.keys(value).length !== 0);
      this.requirementsDataH2 = list1.join(", ") + ".";
    }

    var reqDatH3 = this.ls.get("requirementsDataH3");
    if (reqDatH3 != "") {
      var list3 = [];
      list3.push(reqDatH3.extraPreferencesText);
      list3.push(reqDatH3.floorPreferencesText);
      list3.push(reqDatH3.preferencesText);
      list3.push(reqDatH3.smokingPreferencesText);
      list3 = list3.filter(value => Object.keys(value).length !== 0);
      this.requirementsDataH3 = list3.join(", ") + ".";
    }

    var reqDatH4 = this.ls.get("requirementsDataH4");
    if (reqDatH4 != "") {
      var list4 = [];
      list4.push(reqDatH4.extraPreferencesText);
      list4.push(reqDatH4.floorPreferencesText);
      list4.push(reqDatH4.preferencesText);
      list4.push(reqDatH4.smokingPreferencesText);
      list4 = list4.filter(value => Object.keys(value).length !== 0);
      this.requirementsDataH4 = list4.join(", ") + ".";
    }

    var reqDatH5 = this.ls.get("requirementsDataH5");
    if (reqDatH5 != "") {
      var list5 = [];
      list5.push(reqDatH5.extraPreferencesText);
      list5.push(reqDatH5.floorPreferencesText);
      list5.push(reqDatH5.preferencesText);
      list5.push(reqDatH5.smokingPreferencesText);
      list5 = list5.filter(value => Object.keys(value).length !== 0);
      this.requirementsDataH5 = list5.join(", ") + ".";
    }
  },
  watch: {
    rateNameDC() {
      if(!this.rateNameDC && this.proCode && (this.disCode == "" || this.disCode == null)) {
        this.disCode = this.proCode
      }
      
    }
  },
  methods: {
     
    settingSuppl(resObject) {
// Deeper
this.ls.set('generalUp', true)
var toS = 0
var toIm = 0
for(var i=0; i < resObject.rateOptionalSupplementResponseList.length; i++) {
    toS += resObject.rateOptionalSupplementResponseList[i].amount
    for(var j = 0; j < resObject.rateOptionalSupplementResponseList[i].rateSupplementTaxesResponseList.length; j++) {
            if(resObject.rateOptionalSupplementResponseList[i].rateSupplementTaxesResponseList[j].taxCode == "IVA") {

                toIm += resObject.rateOptionalSupplementResponseList[i].rateSupplementTaxesResponseList[j].taxAmount

            }}
}
this.ls.set('generalSuppl', toS)
this.ls.set('generalSupplIm', toIm)

var extraSupE = 0
var extraSupIE = 0
var extraToSE = 0 

var extraSupEFirstNight = 0
var extraSupIEFirstNight = 0
var extraToSEFirstNight = 0 
var ob = {
            extraSupE: extraSupE,
            extraSupIE: extraSupIE,
            extraToSE: extraToSE
        }
 var ob2 = {
            extraSupE: extraSupEFirstNight,
            extraSupIE: extraSupIEFirstNight,
            extraToSE: extraToSEFirstNight
        }
        this.ls.set('supleCondiOneFirstNight', ob2)
       
        this.ls.set('supleCondi', ob)
        

if(resObject.numberOfNights != null && resObject.numberOfNights != "") {

    var numNuits = resObject.numberOfNights
} else {
    var numNuits = 1
}
if(resObject.rateOptionalSupplementResponseList != null && resObject.rateOptionalSupplementResponseList.length != 0) {
var suplObject = resObject.rateOptionalSupplementResponseList
for(var i=0; i < suplObject.length; i++) {
switch(suplObject[i].quantityType) {
    case 5:
        extraSupE += suplObject[i].amount / numNuits
        for(var j = 0; j < suplObject[i].rateSupplementTaxesResponseList.length; j++) {
            if(suplObject[i].rateSupplementTaxesResponseList[j].taxCode == "IVA") {

                extraSupIE += suplObject[i].rateSupplementTaxesResponseList[j].taxAmount / numNuits

            }
        }
        extraToSE += (extraSupIE + extraSupE)
        var obje = {
            extraSupE: extraSupE,
            extraSupIE: extraSupIE,
            extraToSE: extraToSE
        }
        this.ls.set('supleCondi', obje)
        break;

    case 3:
        extraSupE += suplObject[i].amount / numNuits
        for(var j = 0; j < suplObject[i].rateSupplementTaxesResponseList.length; j++) {
            if(suplObject[i].rateSupplementTaxesResponseList[j].taxCode == "IVA") {

                extraSupIE += suplObject[i].rateSupplementTaxesResponseList[j].taxAmount / numNuits

            }
        }
        extraToSE += (extraSupIE + extraSupE)
        var obje = {
            extraSupE: extraSupE,
            extraSupIE: extraSupIE,
            extraToSE: extraToSE
        }
        this.ls.set('supleCondi', obje)
        
        break;

        
        
     case 1:  case 7:  
        extraSupE += suplObject[i].amount / numNuits
        for(var j = 0; j < suplObject[i].rateSupplementTaxesResponseList.length; j++) {
            if(suplObject[i].rateSupplementTaxesResponseList[j].taxCode == "IVA") {

                extraSupIE += suplObject[i].rateSupplementTaxesResponseList[j].taxAmount / numNuits

            }
        }
        extraToSE += (extraSupIE + extraSupE)
        var obje = {
            extraSupE: extraSupE,
            extraSupIE: extraSupIE,
            extraToSE: extraToSE
        }
        this.ls.set('supleCondi', obje)
        
        break;

        
    case 8:
        extraSupE += suplObject[i].amount / numNuits
        for(var j = 0; j < suplObject[i].rateSupplementTaxesResponseList.length; j++) {
            if(suplObject[i].rateSupplementTaxesResponseList[j].taxCode == "IVA") {

                extraSupIE += suplObject[i].rateSupplementTaxesResponseList[j].taxAmount / numNuits

            }
        }
        extraToSE += (extraSupIE + extraSupE)
        var obje = {
            extraSupE: extraSupE,
            extraSupIE: extraSupIE,
            extraToSE: extraToSE
        }
        this.ls.set('supleCondi', obje)
        
        break;

        
        case 2: case 6:
        extraSupEFirstNight += suplObject[i].amount 
        for(var j = 0; j < suplObject[i].rateSupplementTaxesResponseList.length; j++) {
            if(suplObject[i].rateSupplementTaxesResponseList[j].taxCode == "IVA") {

                extraSupIEFirstNight += suplObject[i].rateSupplementTaxesResponseList[j].taxAmount 

            }
        }
        extraToSEFirstNight += (extraSupIEFirstNight + extraSupEFirstNight)
        var obje = {
            extraSupE: extraSupEFirstNight,
            extraSupIE: extraSupIEFirstNight,
            extraToSE: extraToSEFirstNight
        }
        this.ls.set('supleCondiOneFirstNight', obje)
        
            break;

        case 4:
                 extraSupEFirstNight += suplObject[i].amount 
        for(var j = 0; j < suplObject[i].rateSupplementTaxesResponseList.length; j++) {
            if(suplObject[i].rateSupplementTaxesResponseList[j].taxCode == "IVA") {

                extraSupIEFirstNight += suplObject[i].rateSupplementTaxesResponseList[j].taxAmount 

            }
        }
        extraToSEFirstNight += (extraSupIEFirstNight + extraSupEFirstNight)
        var obje = {
            extraSupE: extraSupEFirstNight,
            extraSupIE: extraSupIEFirstNight,
            extraToSE: extraToSEFirstNight
        }
        this.ls.set('supleCondiOneFirstNight', obje)
            break;
        
    default:
        break;
} 

}
}

    },
    suplementProforma() {
     var supplement = this.ls.get("opSuE"); //opSuE var supplement = this.ls.get("supplement");
      if (supplement == 0) { // supplement.data.supplementMandatoryResponseList.length
        this.banSuplement = false;
      } else {
        this.listSuplement = supplement //supplement.data.supplementMandatoryResponseList;
        for(var i=0; i < this.listSuplement.length; i++) {
          this.supleER += this.datosHabHotSelected.habitacion.totalRooms * this.listSuplement[i].numSuppleCharged
          this.supleER += " "
          this.supleER += this.listSuplement[i].supplementName
          this.supleER += ", "
        }
          this.supleER = this.supleER.slice(0, -2)

        this.banSuplement = true;
      }
    this.ls.set('opSuE', null)

    },
    tooltipInfo() {},
    closeModalTarifa() {
      this.banDetalleCosto = false;
    },
    closeModalTarifaTooltip() {
      this.banDetalleCostoTooltip = false;
    },
    cargarInfoLocalStorage() {
      let datosHabHotSelected = this.ls.get("datosHabHotSelected");
      this.clientIdLogin = this.ls.get("ClientId").data;
      GlobalServices._consultaProfileById(this.ls.get('Token').data, this.ls.get('Language').data, this.clientIdLogin).then(response => {
        this.nombreCompania = response.data.genericName;
      });
      this.infoCosto = datosHabHotSelected;

      this.datosHabHotSelected = datosHabHotSelected.data;
      if(this.datosHabHotSelected.habitacion.totalRooms != "" && this.datosHabHotSelected.habitacion.totalRooms != null && this.datosHabHotSelected.habitacion.totalRooms != 0) {
          this.plusDeChambres = this.datosHabHotSelected.habitacion.totalRooms
      }
      // Set roomName
      if (this.ls.get("roomNameSW") != null && this.ls.get("allowF")) {
        this.datosHabHotSelected.hotel.title = this.ls.get("roomNameSW");
      }
      // Set roomName
      this.ls.remove("roomNameSW");
      if (
        String(
          this.datosHabHotSelected.hotel.negotiatedRatesDetailPrice
            .totalRateWithTaxes
        ).includes(",")
      ) {
        var nA = this.datosHabHotSelected.hotel.negotiatedRatesDetailPrice.totalRateWithTaxes.replace(
          ",",
          ""
        );
        this.datosHabHotSelected.hotel.negotiatedRatesDetailPrice.totalRateWithTaxes = nA;
      }

      if (this.datosHabHotSelected.hotel.benefitsRestrictions == null) {
        this.block1 = false;
        this.block2 = false;
      } else {
        this.block1 = true;
        this.block2 = true;
      }

      for (var i = 0; i < this.ls.get("responseReservation").data.length; i++) {
        this.reservationResponse.push({
          id: i + 1,
          reservationNumber: this.ls.get("responseReservation").data[i]
            .numReservation
        });
        if (
          this.reservationResponse[i].reservationNumber == "0" ||
          this.reservationResponse[i].reservationNumber == 0
        ) {
          this.reservationResponse[i].reservationNumber = "";
        }
      }
      if (this.ls.get("responseReservation").data.length == 0) {
        this.policiesNow = "";
      } else {
        this.policiesNow = this.ls.get("responseReservation").data[0].policies;
      }
    },
    redirectAvisoPrivacidad() {
      (this.ls.get('Language').data=='es'?window.open(process.env.VUE_APP_POLICIES, '_blank'):window.open(process.env.VUE_APP_POLICIESEN, '_blank'));
    },
    verDetalleTooltip() {
      // Modal DetalleCosto
      const datosHabHotSelected = this.ls.get("datosHabHotSelected");
      if (datosHabHotSelected.data.hotel.benefitsRestrictions.length == 0) {
        this.rateDescriptionText = "";
        this.rateBenefitsText = "";
        this.rateBenefitsRestrictions = "";
      } else {
        this.rateDescriptionText =
          datosHabHotSelected.data.hotel.benefitsRestrictions.rateName;
        this.rateBenefitsText =
          datosHabHotSelected.data.hotel.benefitsRestrictions.benefits;
        this.rateBenefitsRestrictions =
          datosHabHotSelected.data.hotel.benefitsRestrictions.restrictions;
      }

      if (
        datosHabHotSelected.data.hotel.negotiatedRatesDetailPrice
          .ratesDetailResponses[0].commissionableRate == false
      ) {
        this.showTable = false;
      } else {
        this.showTable = true;
        this.modalListCosteContract =
          datosHabHotSelected.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[0].commissionResponse.contract;
        this.modalListCosteBaseAmount =
          datosHabHotSelected.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[0].commissionResponse.baseAmount;
        this.modalListCosteCommissionPercentage =
          datosHabHotSelected.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[0].commissionResponse.commissionPercentage;
        this.modalListCosteCommissionAmount =
          datosHabHotSelected.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[0].commissionResponse.commissionAmount;
      }
      // Fin Modal DetalleCosto

      this.componentKey += 1;
      this.banDetalleCostoTooltip = true;
    },  changePolicys(policyDesc, rate,guiones,rateActive,tCliente){ 
      //KB48764 m.a.cortes  
       
      if(policyDesc.includes(this.twoPolicy) || policyDesc.includes(this.twoPolicyEn) ){         
         let rateUltimateTwo = this.average/this.noches;
        var twonoches= rateUltimateTwo*2;
        twonoches = twonoches.toFixed(2);
        policyDesc= policyDesc.replace(rate,`$${twonoches.toLocaleString('en')}`);      
       }else{      
          let rateUltimate = this.average/this.noches;    
          rateUltimate = rateUltimate.toFixed(2);          
          policyDesc= policyDesc.replace(rate,`$${rateUltimate.toLocaleString('en')}`);
       }        
       if(tCliente=='PYP'||tCliente=='PYPSA'){
          if(rateActive==1){
          policyDesc=policyDesc.replace(rate,guiones);
              }
          policyDesc=policyDesc;
          return policyDesc;
            }
      return policyDesc;
	  },
    verDetalle() {
      this.banDetalleCosto = true;
      this.componentKey += 1;

        // Sending only the selected supplements
    var dataE = {
      rateOptionalSupplementResponseList : [],
      numberOfNights: this.datosHabHotSelected.hotel.nights
    }  
    // for normal workflows
    if(this.$store.getters.getOptionalSupplements.length != 0) {
            if(this.$store.getters.getOptionalSupplements.optionalSupplementsObject != null && this.$store.getters.getOptionalSupplements.optionalSupplementsObject.length != 0) {
    for(var i = 0; i < this.$store.getters.getOptionalSupplements.optionalSupplementsObject.length; i++) {
          dataE.rateOptionalSupplementResponseList.push(this.$store.getters.getOptionalSupplements.optionalSupplementsObject[i].reqOpcional)
    }
    } 
    }

    // After read only edition
    if(this.listRequeOpcionalesSeleccionados.length != 0) {
    for(var i = 0; i < this.listRequeOpcionalesSeleccionados.length; i++) {
          dataE.rateOptionalSupplementResponseList.push(this.listRequeOpcionalesSeleccionados[i].reqOpcional)
    }
    } 
    this.settingSuppl(dataE)
    // Sending only the selected supplements
      setTimeout(() => {
        this.$bvModal.show("detalleDeCosto1");
      }, 1);
    },
    newReservation() {
      if(this.groupBool)
      {
        this.$router.push({ name: "ReservacionesConfirmacion" });
      }
      else{
      GlobalFunctions.cleanLocalStorageOfReserva();
      var reset = null;
      this.ls.set("rateNameDiscountCode", reset);
      this.$store.commit("blockLanguages", { turn: false });

      this.$router.push({ name: "ReservacionesConfirmacion" });
    }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/config.scss";

.contentContacto {
  display: flex;
  position: relative;
  min-height: 70vh;
}

i:before {
  margin-left: 0px !important;
}

i {
  font-size: 24px;
}

.navi {
  float: right;
  font-size: 20px !important;
}

.camposActive {
  color: #0c5458;
  font-weight: 500;
}

.card-deck:first-child {
  .card {
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
  }
}

.card-deck:nth-child(n + 2) {
  .card {
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    border-top: none;
  }
}

.card-deck:last-child {
  .card {
    border-bottom-left-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
  }
}

.contacto {
  width: 100%;
  margin-top: 57px;
  padding-top: 32px;

  .card-body {
    min-height: 10px;

    .card-title {
      font-size: $font-size-large;
    }
  }

  .estancia {
    font-size: $font-size-biglarge;
    font-weight: bold;
  }
}

.cancelarReserva {
  .card-header {
    background-color: #d4edda;
    color: #006900;
  }

  .referencia {
    color: $colorBase2;
  }
}

.enlacesContacto {
  color: $colorBase2;
  font-weight: 500;

  .demo-icon {
    font-size: $font-size-biglarge;
  }
}

.infoResaltado {
  font-size: 14px;
  font-weight: 500;
}

.info {
  font-size: 14px;
}

.icon-info {
  font-size: 20px;
  color: #005a83;
}

.cardInfoRegistro {
  position: fixed;
  max-width: 290px;
}

.tituloInfo {
  font-size: 15px;
  font-weight: bold;
}

.parrafoInfo {
  font-size: 14px;
  font-weight: 500;
}

.infoHabitacion {
  font-size: 14px;
  font-weight: normal;
}

.demo-icon {
  font-size: 18px;
}

.moneda {
  font-size: 12px;
  font-weight: 500;
}

.enlaceDetalle {
  font-size: 14px;
  font-weight: 500;
  color: #005a83;
}

.azul {
  color: #005a83;
  font-weight: 500;
}

.botonesInfo {
  left: 50%;
}

.numConfimacion {
  display: inline;
}

@media only screen and (max-width: 992px) {
  .botonesInfo {
    left: 0;
  }

  .numConfimacion {
    display: block;
  }

  .card-deck .card {
    margin-bottom: 0px;
  }
}
</style>
